 <template id="template-input">
  <div :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'">
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :isHidden="isHidden"
      :label="label"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
      v-on:toggle-field="showSettings=!showSettings"
      v-on:collapse-field="collapse=!collapse"
    />

    <!-- input content -->
    <b-collapse
      v-show="JSON.parse(!fieldData.isHidden)"
      id="collapse-1"
      :class="isPreview ? 'mt-0': 'mt-5'"
      v-model="collapse"
    >
      <b-col class="text-left">
        <!-- <b-link href="#foo">{{fieldData.label[selectedLanguage]}}</b-link> -->
        <!-- href="#foo" -->

        <b-link
          class="text-capitalize"
          target="blank"
          v-if="fieldData.linkForm"
          @click="getTaskForm(fieldData.linkedTraining)"
        >{{fieldData.selectedForm.title}}</b-link>
      </b-col>
    </b-collapse>

    <b-modal
      cancel-title="Close"
      ok-title="save"
      size="lg"
      v-model="showSettings"
      scrollable
      title="Link  Settings"
    >
      <AdvanceHeadingSettings
        :fieldData="fieldData"
        v-on:toggle-field="showSettings=!showSettings"
        :sectionIndex="sectionIndex"
        :fieldIndex="fieldIndex"
      />
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import AdvanceHeadingSettings from "../advanceHeadingSettingsComponent";
import MenuButtons from "../menuButtons";
import { mapGetters, mapState } from "vuex";
import { HTTP } from "../../utils/HTTP";
export default {
  name: "Hyperlink",
  components: {
    AdvanceHeadingSettings,
    MenuButtons
  },
  data() {
    return {
      isHidden: false,
      condition: {},
      showToolTip: false,
      label: undefined,
      placeholder: undefined,
      tooltipText: undefined,
      showSettings: false,
      collapse: true,
      h1Name: this.fieldData.label[this.selectedLanguage]
    };
  },
  mounted() {
    this.h1Name = this.fieldData.label[this.selectedLanguage];
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage"]),
    ...mapState(["toggleAllCoppalse"])
  },
  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    }
  },
  methods: {
    setValue(e) {
      this.h1Name = e;
      this.fieldData.label[this.selectedLanguage] = this.h1Name;
    },

    async getTaskForm(training) {
      let userId = localStorage.getItem("userId");

      // console.log(
      //   "formId, formType, taskId",
      //   training.formId,
      //   training,
      //   training.id
      // );
     let routeData = this.$router.resolve({path: '/user-training', query: {id: training.id }})
      window.open(routeData.href, '_blank');
      // this.$router.push({
      //   path: newRoute,
      //   params: {
      //     from: "/link"
      //   }query: {data: "someData"}}
      // });

      

     
    }
  },
  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number
  }
};
</script>
<style scoped>
.custom-input-tag-h1 {
  background-color: transparent;
  height: 60px;
  font-size: 36px;
  border: 0;
  width: auto;
}
.custom-input-tag-h2 {
  background-color: transparent;
  height: 50px;
  font-size: 26px;
  border: 0;
  width: auto;
}
.custom-input-tag-h3 {
  background-color: transparent;
  height: 40px;
  font-size: 20px;
  border: 0;
  width: auto;
}
</style>
